$(document).ready(function() {
  $('[data-stepper="custom-dropdown"]').each(function() { initCustomDropdown(this); });
  $('[data-stepper="select"]').each(function() { initMaterializeSafeSelect(this); });
  $('[data-stepper="number"]').each(function() { initNumberStepper(this); });
  bindRuntimeCascade();

  // Handle course-email-* language panel switching directly (courses.coffee may not fire
  // because its data-prev is initialized from #course_name_language which doesn't exist here).
  (function() {
    const $langSelect = $('#email_language_id');
    if (!$langSelect.length) return;
    let prevLangId = $langSelect.val();
    $langSelect.on('change', function() {
      const currentLangId = $(this).val();
      $('.course-email-' + prevLangId).css('display', 'none');
      $('.course-email-' + currentLangId).css('display', 'block');
      prevLangId = currentLangId;
    });
  })();

  const $toggle = $('.notifications-toggle__input');
  const $reminders = $('#reminders-section');

  $toggle.on('change', function() {
    $reminders.toggleClass('hidden', !this.checked);
  });

  $(document).on('click', function() {
    $('.stepper__dropdown.is-open').removeClass('is-open');
    $('[data-stepper="custom-dropdown"]').removeClass('dropdown-open');
  });

  // Capture panel refs before Materialize moves the selects out of the DOM tree.
  // $(this).closest() on the select itself fails after Materialize wraps it.
  $('[data-stepper="custom-dropdown"]').each(function() {
    const $stepper = $(this);
    const $select = $stepper.find('.stepper__select');
    if (!$select.length) return;
    const name = $select.attr('name') || '';
    if (name.indexOf('_email_type') < 0) return;
    const $settings = $stepper.closest('.email-customisation-panel').find('[class^="customised-"]');
    $select.on('change', function() {
      const isCustom = $(this).val() === 'Customise';
      $settings.toggle(isCustom);
      if (isCustom) {
        const currentLangId = $('#email_language_id').val();
        if (currentLangId) {
          $settings.find('[class^="course-email-"]').css('display', 'none');
          $settings.find('.course-email-' + currentLangId).css('display', 'block');
        }
      }
    });
  });

  function initCustomDropdown(stepper) {
    const select  = $(stepper).find('.stepper__select');
    if (!select.length) return;

    const display = $('<span class="stepper__display">');
    display.insertBefore($(stepper).find('.stepper__arrow'));

    const ul = $('<ul class="stepper__dropdown" role="listbox">');
    $(stepper).append(ul);

    function renderOptions() {
      display.text(select.find('option:selected').text());
      ul.empty();
      select.find('option').each(function() {
        const opt = $(this);
        const li  = $('<li>').text(opt.text()).data('value', opt.val())
                             .attr({ role: 'option', tabindex: '-1' });
        if (opt.is(':selected')) li.addClass('is-selected').attr('aria-selected', 'true');
        li.click(function(e) {
          e.stopPropagation();
          selectOption(opt.val(), opt.text(), li);
        });
        li.keydown(function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            selectOption(opt.val(), opt.text(), li);
          }
        });
        ul.append(li);
      });
    }

    renderOptions();

    $(stepper).attr({ tabindex: '0', role: 'combobox', 'aria-haspopup': 'listbox', 'aria-expanded': 'false' });

    function openDropdown() {
      $('.stepper__dropdown.is-open').removeClass('is-open');
      $('[data-stepper="custom-dropdown"]').removeClass('dropdown-open').attr('aria-expanded', 'false');
      ul.addClass('is-open');
      $(stepper).addClass('dropdown-open').attr('aria-expanded', 'true');
      ul.find('li.is-selected').focus();
    }

    function closeDropdown() {
      ul.removeClass('is-open');
      $(stepper).removeClass('dropdown-open').attr('aria-expanded', 'false');
      $(stepper).focus();
    }

    function selectOption(val, text, li) {
      select.val(val);
      display.text(text);
      ul.find('li').removeClass('is-selected').attr('aria-selected', 'false');
      li.addClass('is-selected').attr('aria-selected', 'true');
      closeDropdown();
      select.trigger('change');
    }

    $(stepper).click(function(e) {
      e.stopPropagation();
      ul.hasClass('is-open') ? closeDropdown() : openDropdown();
    });

    $(stepper).keydown(function(e) {
      const isOpen = ul.hasClass('is-open');
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        isOpen ? closeDropdown() : openDropdown();
      } else if (e.key === 'Escape') {
        if (isOpen) { e.preventDefault(); closeDropdown(); }
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!isOpen) openDropdown();
        const items = ul.find('li');
        const focused = ul.find('li:focus');
        const idx = items.index(focused);
        const next = e.key === 'ArrowDown'
          ? items.eq(idx < items.length - 1 ? idx + 1 : 0)
          : items.eq(idx > 0 ? idx - 1 : items.length - 1);
        next.focus();
      }
    });

    // Lets the runtime-day cascade rebuild this dropdown's options/selection in place.
    $(stepper).data('setOptions', function(options, selectedValue) {
      select.empty();
      options.forEach(function(opt) {
        select.append($('<option>').val(opt.value).text(opt.label));
      });
      const hasSelected = options.some(function(opt) { return String(opt.value) === String(selectedValue); });
      select.val(hasSelected ? selectedValue : options[0].value);
      renderOptions();
      select.trigger('change');
    });
  }

  // Mirrors CoursesHelper#course_runtime_days so the Reminder day options stay in
  // sync with the unsaved "Course runtime in days" value, like the old course settings tab.
  function getRuntimeDayOptions(initial, final) {
    const noInitial = initial === null || initial === undefined || initial === '-';
    if (noInitial || !final || final <= 0) return [{ value: '-', label: '-' }];

    const options = [{ value: '-', label: '-' }];
    for (let i = parseInt(initial, 10) + 1; i <= final; i++) {
      options.push({ value: String(i), label: String(i) });
    }
    return options;
  }

  function bindRuntimeCascade() {
    const $courseRuntime = $('#course_runtime');
    if (!$courseRuntime.length) return;

    const reminderSteppers = [1, 2, 3].map(function(i) {
      return $('#course_remind_completion_runtime_' + i).closest('[data-stepper="custom-dropdown"]');
    });

    function courseRuntimeValue() {
      return parseInt($courseRuntime.val(), 10) || 0;
    }

    $courseRuntime.on('change', function() {
      const setOptions = reminderSteppers[0].data('setOptions');
      if (setOptions) setOptions(getRuntimeDayOptions(0, courseRuntimeValue()), '-');
    });

    [1, 2].forEach(function(i) {
      $('#course_remind_completion_runtime_' + i).on('change', function() {
        const setOptions = reminderSteppers[i].data('setOptions');
        if (!setOptions) return;
        const currentVal = $(this).val();
        const initial = (!currentVal || currentVal === '-') ? '-' : parseInt(currentVal, 10);
        setOptions(getRuntimeDayOptions(initial, courseRuntimeValue()), '-');
      });
    });
  }

  function initMaterializeSafeSelect(stepper) {
    const select = $(stepper).find('.stepper__select')[0];
    if (!select) return;

    const observer = new MutationObserver(function() {
      const parent = select.parentElement;
      if (parent && parent.classList.contains('select-wrapper')) {
        parent.parentElement.insertBefore(select, parent);
        parent.remove();
        select.style.display = '';
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initNumberStepper(stepper) {
    const input = $(stepper).find('.stepper__input');
    if (!input.length) return;

    $(stepper).find('.stepper__btn--up').click(function() {
      input[0].stepUp();
      input.trigger('change');
    });
    $(stepper).find('.stepper__btn--down').click(function() {
      if (parseInt(input.val()) > parseInt(input.attr('min') || 0)) {
        input[0].stepDown();
        input.trigger('change');
      }
    });
  }
});
